import React from 'react';
import { Navigate } from 'react-router-dom';
import withIntegrations from '../utils/withIntegrations';

const IntegrationPage = () => <Navigate to="/profile#integrations" replace />;

export default withIntegrations(IntegrationPage);
